module.exports = __webpack_public_path__ + "static/media/delete.eeddce72.svg";